import React, { useState, useEffect } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import axios from "axios";

const Address = () => {
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [editingAddress, setEditingAddress] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 425);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 425);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [formData, setFormData] = useState({
    addressLine: "",
    location: "",
    landMark: "",
    pincode: "",
    state: "",
    city: "",
    category: "Home",
  });

  const categories = ["Home", "Office", "Other"];

  const token = localStorage.getItem("authToken"); // ✅ get auth token

  // Fetch addresses
  const fetchAddresses = async () => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      alert("❌ User ID not found. Please log in again.");
      return;
    }

    try {
      const response = await axios.get(
        `https://backend.maamaas.com/subscription/api/location/user/addresses/${userId}`,
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        }
      );
      console.log("Fetched addresses:", response.data);
      setAddresses(response.data);
    } catch (error) {
      console.error("Error fetching addresses:", error);
    }
  };

  useEffect(() => {
    fetchAddresses();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const openModal = () => {
    setFormData({
      addressLine: "",
      location: "",
      landMark: "",
      pincode: "",
      state: "",
      city: "",
      category: "Home",
    });
    setEditingAddress(null);
    setIsOpen(true);
  };

  const closeModal = () => setIsOpen(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const userId = localStorage.getItem("userId");
    if (!userId) {
      alert("❌ User ID not found.");
      setLoading(false);
      return;
    }

    const requestBody = {
      ...formData,
      userId: Number(userId),
      pincode: Number(formData.pincode),
    };

    try {
      if (editingAddress) {
        // ✅ UPDATE: PUT request with token
        await axios.put(
          `https://backend.maamaas.com/subscription/api/location/update/${editingAddress}`,
          requestBody,
          {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
          }
        );
        alert("✅ Address updated successfully!");
      } else {
        // ✅ ADD: POST request with token
        await axios.post(
          `https://backend.maamaas.com/subscription/api/location/add`,
          requestBody,
          {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
          }
        );
        alert("✅ Address added successfully!");
      }

      fetchAddresses(); // Refresh list
      closeModal();
      setEditingAddress(null);
      setFormData({
        addressLine: "",
        location: "",
        landMark: "",
        pincode: "",
        state: "",
        city: "",
        category: "Home",
      });
    } catch (error) {
      console.error("Error saving address:", error.response?.data || error.message);
      alert("❌ Failed to save address.");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (address) => {
    setEditingAddress(address.addressId || address.id);
    setFormData({
      addressLine: address.addressLine || "",
      location: address.location || "",
      landMark: address.landMark || "",
      pincode: address.pincode || "",
      state: address.state || "",
      city: address.city || "",
      category: address.category || "Home",
    });
    setIsOpen(true);
  };

  const handleDelete = async (addressId) => {
    if (!addressId) {
      alert("❌ Invalid address ID.");
      return;
    }

    const confirmDelete = window.confirm("Are you sure you want to delete this address?");
    if (!confirmDelete) return;

    try {
      await axios.delete(
        `https://backend.maamaas.com/subscription/api/location/delete/${addressId}`,
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        }
      );
      alert("✅ Address deleted successfully!");
      fetchAddresses();
    } catch (error) {
      console.error("Error deleting address:", error.response || error.message);
      alert("❌ Failed to delete address.");
    }
  };
  const tableStyle = {
    width: isMobile ? "max-content" : "100%",
    borderCollapse: "collapse",
    minWidth: isMobile ? "600px" : "100%"
  };

  const containerStyle = {
    width: "100%",
    marginTop: "20px",
    overflowX: isMobile ? "auto" : "visible",
    WebkitOverflowScrolling: "touch" // Smooth scrolling on iOS
  };

  return (
    <div>
      <h2
        style={{
          width: "156px",
          backgroundColor: "rgb(177 93 198)",
          color: "#fff",
          padding: "10px",
          borderRadius: "5px",
          textAlign: "center",
          cursor: "pointer",
          fontSize: "20px",
          marginTop: "20px",
        }}
        onClick={openModal}
      >
        Add Address +
      </h2>

      {isOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 999,
          }}
        >
          <div
            style={{
              background: "#fff",
              width: "420px",
              borderRadius: "16px",
              padding: "25px",
              position: "relative",
              boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
              animation: "fadeIn 0.3s ease-in-out",
            }}
          >
            <span
              onClick={closeModal}
              style={{
                position: "absolute",
                top: "12px",
                right: "18px",
                fontSize: "26px",
                cursor: "pointer",
                color: "#666",
              }}
              onMouseOver={(e) => (e.target.style.color = "#e74c3c")}
              onMouseOut={(e) => (e.target.style.color = "#666")}
            >
              ×
            </span>

            <h3
              style={{
                textAlign: "center",
                fontSize: "20px",
                fontWeight: "600",
                marginBottom: "20px",
                color: "#333",
              }}
            >
              {editingAddress ? "Edit Address" : "Add New Address"}
            </h3>

            <form
              onSubmit={handleSubmit}
              style={{ display: "flex", flexDirection: "column", gap: "12px" }}
            >
              <input
                type="text"
                name="addressLine"
                placeholder="Door / House No"
                value={formData.addressLine}
                onChange={handleChange}
                required
                style={inputStyle}
              />

              <input
                type="text"
                name="landMark"
                placeholder="Landmark"
                value={formData.landMark}
                onChange={handleChange}
                required
                style={inputStyle}
              />

              <input
                type="number"
                name="pincode"
                placeholder="Pincode"
                value={formData.pincode}
                onChange={handleChange}
                required
                style={inputStyle}
              />

              <input
                type="text"
                name="state"
                placeholder="State"
                value={formData.state}
                onChange={handleChange}
                required
                style={inputStyle}
              />

              <input
                type="text"
                name="city"
                placeholder="City"
                value={formData.city}
                onChange={handleChange}
                required
                style={inputStyle}
              />

              <select
                name="category"
                value={formData.category}
                onChange={handleChange}
                required
                style={inputStyle}
              >
                {categories.map((cat) => (
                  <option key={cat} value={cat}>
                    {cat}
                  </option>
                ))}
              </select>

              <button
                type="submit"
                disabled={loading}
                style={{
                  background: loading ? "#a0cbe8" : "#4cafef",
                  color: "#fff",
                  padding: "12px",
                  border: "none",
                  borderRadius: "10px",
                  fontSize: "15px",
                  cursor: loading ? "not-allowed" : "pointer",
                  transition: "0.3s",
                }}
                onMouseOver={(e) =>
                  !loading && (e.target.style.background = "#3a9bdc")
                }
                onMouseOut={(e) =>
                  !loading && (e.target.style.background = "#4cafef")
                }
              >
                {loading
                  ? "Saving..."
                  : editingAddress
                    ? "Update Address"
                    : "Add Address"}
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Address Table */}
      <table style={{ width: "100%", marginTop: "0px", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ background: "rgb(177 93 198)", color: "#fff" }}>
            <th>S.No</th>
            <th>Category</th>
            <th>Landmark</th>
            <th>Door No</th>
            <th>District</th>
            <th>State</th>
            <th>Pincode</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {addresses.map((addr, i) => (
            <tr key={addr.addressId || addr.id}>
              <td>{i + 1}</td>
              <td>{addr.category || "N/A"}</td>
              <td>{addr.landMark || "N/A"}</td>
              <td>{addr.addressLine || "N/A"}</td>
              <td>{addr.city || "N/A"}</td>
              <td>{addr.state || "N/A"}</td>
              <td>{addr.pincode || "N/A"}</td>
              <td>
                <FaEdit
                  style={{ color: "blue", cursor: "pointer", marginRight: "10px", fontSize: "16px" }}
                  onClick={() => handleEdit(addr)}
                />
                <FaTrash
                  style={{ color: "red", cursor: "pointer", fontSize: "16px" }}
                  onClick={() => handleDelete(addr.addressId || addr.id)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const inputStyle = {
  padding: "12px",
  borderRadius: "10px",
  border: "1px solid #ccc",
  outline: "none",
  fontSize: "14px",
};

export default Address;
